export class currentInventory{
    _id:any;
    accountId:any;
    accountEmailId:any;
    productUniqueNumber:any;
    productName:any;
    description:any;
    stockQuantity:any;
    stockUnit:any;
    purchaseDate:any;
    expiryDate:any;
    storageLocation:any;
    borrowed:any;
    category:any;
    otherCategory:any;
    otherSubCategory:any;
    subCategory:any;
    orderId:any;
    vendorId:any;
    uploadType:any
    status:any;
    productImage:any;
    price:any;
    productStatus:any;
    adminId:any;
    adminEmailId:any
    updatingQuantity:any
}